import {Col, Layout, Row} from "antd";
import Flex from "../Flex";
import {useEffect} from "react";
import AppConfig from "../../service/AppConfig";

export default function SimpleLayout({children, fullWidth=false})
{
    useEffect(() => {
        document.title =  AppConfig.getHisTitle()
    }, []);

    return (
        <Layout style={{marginTop: 80, marginLeft: 24, marginBottom: 16, marginRight: 16}}>
            <Row justify={'center'}>
                <Col xs={24} sm={24} md={24} lg={fullWidth ? 24 : 18} xl={fullWidth ? 24 : 14} xxl={fullWidth ? 24 : 12}>
                    {children}
                </Col>
            </Row>
        </Layout>
    )
}